module.exports = __webpack_public_path__ + "static/media/welcome_background.f7d89509.jpg";